"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _excluded = ["id", "rows", "cells"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var removeExistingIds = function removeExistingIds(state) {
  var id = state.id,
      rows = state.rows,
      cells = state.cells,
      restOfState = _objectWithoutProperties(state, _excluded);

  if ((rows || []).length > 0) {
    restOfState.rows = rows.map(removeExistingIds);
  } else if ((cells || []).length > 0) {
    restOfState.cells = cells.map(removeExistingIds);
  }

  return restOfState;
};

var _default = removeExistingIds;
exports["default"] = _default;